import { Injectable } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { IRequest } from "ngxs-requests-plugin";
import { DownloadOptionsGetterState } from "../ngxs/download-options/download-options-getter.state";
import { GetDownloadOptionsRequestState } from "../ngxs/download-options/download-options.state";
import { GetDownloadOptions } from "../ngxs/download-options/download-options.actions";

@Injectable({
  providedIn: 'root',
})
export class DownloadOptionsService {
  @Select(DownloadOptionsGetterState.getDownloadOptions)
  downloadOptions$: Observable<any>;

  @Select(GetDownloadOptionsRequestState)
  getDownloadOptionsRequestState$: Observable<IRequest>;

  constructor(
    private store: Store
  ) {}

  getDownloadOptions() {
    this.store.dispatch(new GetDownloadOptions());
  }

  getDownloadOptionsSnapshot() {
    return this.store.selectSnapshot(DownloadOptionsGetterState.getDownloadOptions);
  }
}